export const FIND_LOWER_PRICE_MODAL = 'findLowerPrice'
export const FIND_LOWER_PRICE_MODAL_PAGE_SRC = '/modals/find-lower-price'
export const FIND_LOWER_PRICE_MODAL_ROOT_TYPE = 'ModalBox'
